import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

import { EventContainer, EventInfoContainer } from "../styled/scheduler";

import Info from "./event/info";
import Detail from "./event/detail";
import Report from "./event/report";
import Comment from "./event/comment";
import Gallery from "./event/gallery";
import Members from "./event/members";
import TabMenu from "./event/tabMenu";
import MediaViewer from "../../../../../common/mediaViewer";

import { useModal } from "../../../../../hooks/useModal";
import { useLocation } from "react-router";

const Event = ({
  eventInfo,
  setEventInfo,
  setShowEvent,
  submitDelete,
  getSchedule,
  searchTxt = "",
  exitSchedule = null,
  onDate = null,
}) => {
  const { pathname } = useLocation();

  const isProject = pathname.includes("project");
  const isSchedule = eventInfo.dday === "N";

  const { modal, openModal, closeModal } = useModal();
  const { isDarkMode } = useSelector((state) => state.scheduler);

  const [active, setActive] = useState(0);
  const [isDetail, setIsDetail] = useState(false);
  const [imageOrder, setImageOrder] = useState([]);
  const [todos, setTodos] = useState([]);
  const [originImages, setOriginImages] = useState([]);
  const [comments, setComments] = useState([]);
  const [isUpload, setIsUpload] = useState(false);

  useEffect(() => {
    getComment();
    getImages();
  }, []);

  // 댓글 조회
  const getComment = async () => {
    const url = "/api/scheduleComment/get";
    const body = { scheduleNo: eventInfo.scheduleNo };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setComments(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 이미지 조회
  const getImages = async () => {
    const url = "/api/photoList";
    const body = {
      refeNo: eventInfo.scheduleNo,
    };

    const res = await axios.post(url, body);

    setOriginImages(res.data);
  };

  const clickGallery = (flag) => {
    setIsUpload(flag);
    setActive(2);
  };

  const renderComponent = () => {
    const components = [
      <Detail
        eventInfo={eventInfo}
        isSchedule={isSchedule}
        setTodos={setTodos}
        todos={todos}
        setActive={setActive}
      />,
      <Report
        eventInfo={eventInfo}
        isSchedule={isSchedule}
        setTodos={setTodos}
        todos={todos}
        setIsDetail={setIsDetail}
        setImageOrder={setImageOrder}
        isGallery={true}
        setActive={setActive}
        originImages={originImages}
        clickGallery={clickGallery}
        isUpload={isUpload}
        isProject={isProject}
      />,
      <Gallery
        eventInfo={eventInfo}
        setImageOrder={setImageOrder}
        setIsDetail={setIsDetail}
        isGallery={true}
        setActive={setActive}
        originImages={originImages}
        getImages={getImages}
        clickGallery={clickGallery}
        isUpload={isUpload}
        isProject={isProject}
        row={2}
        getComment={getComment}
      />,
      <Comment
        eventInfo={eventInfo}
        comments={comments}
        getComment={getComment}
        isProject={isProject}
        setImageOrder={setImageOrder}
        setIsDetail={setIsDetail}
        getImages={getImages}
      />,
      <Members eventInfo={eventInfo} />,
    ];
    return components[active];
  };

  return (
    <>
      {modal}
      {isDetail && (
        <MediaViewer
          files={imageOrder}
          setIsOpen={setIsDetail}
          isComment={true}
          getImages={() => {
            getImages();
            getComment();
          }}
        />
      )}
      <EventContainer
        onClick={(e) => e.target === e.currentTarget && setShowEvent(false)}
        className={`${`${isSchedule ? "schedule" : "d-day"} ${isProject ? "" : isDarkMode}`}`}>
        <div className="content">
          <Info
            submitDelete={submitDelete}
            exitSchedule={exitSchedule}
            setEventInfo={setEventInfo}
            isSchedule={isSchedule}
            setShowEvent={setShowEvent}
            setActive={setActive}
            active={active}
            eventInfo={eventInfo}
            openModal={openModal}
            closeModal={closeModal}
            todos={todos}
            getSchedule={getSchedule}
            searchTxt={searchTxt}
            comments={comments}
            isUpload={isUpload}
            onDate={onDate}
            isProject={isProject}
          />
          {renderComponent()}
          {active === 0 && isSchedule && (
            <TabMenu
              isProject={isProject}
              setActive={setActive}
              comments={comments}
              images={originImages}
              clickGallery={clickGallery}
            />
          )}
        </div>
      </EventContainer>
    </>
  );
};

export default Event;
